/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const submitManualClearing = /* GraphQL */ `mutation SubmitManualClearing(
  $documentIds: [String!]!
  $reason: String!
  $comment: String
) {
  submitManualClearing(
    documentIds: $documentIds
    reason: $reason
    comment: $comment
  ) {
    status
    error {
      message
      __typename
    }
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitManualClearingMutationVariables,
  APITypes.SubmitManualClearingMutation
>;
